import React from 'react';
import styled from 'styled-components';
import logoWithTextBlue from '../../../assets/logoWithTextDarkBlue.svg';
import { OnlineThemeType } from '../../../themes/online';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

// ############################ Styles ############################
// tslint:disable:variable-name

const STop = styled.section(
  (props: { theme: OnlineThemeType }) => `
  padding: ${props.theme.spacing.medium}px ${props.theme.spacing.larger}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media only screen and ${props.theme.device.laptop} {
    padding: ${props.theme.spacing.large2}px 0;
  }
`
);

const SLogoWrap = styled.div`
  max-width: 150px;
  img {
    max-width: 100%;
  }
`;

const SPrivacyWrap = styled.div<{}>(
  ({ theme }) => `
  max-width: 124px;
  text-decoration: none;
  font-size: ${theme.font.size.smallMedium};
`
);

const SPrivacyLink = styled.a<{}>(
  ({ theme }) => `
  text-decoration: none;
  color: ${theme.colors.primaryLightBlue};
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

// tslint:disable-next-line:variable-name
const Top: React.FC = () => (
  <STop data-at="top" data-dd-privacy={PrivacyOptions.Allow}>
    <SLogoWrap>
      <img src={logoWithTextBlue} alt="logo" />
    </SLogoWrap>
    <SPrivacyWrap>
      <SPrivacyLink href="https://sunbit.com/consumer_privacy/" target="_blank">
        Privacy Policy
      </SPrivacyLink>
    </SPrivacyWrap>
  </STop>
);

export default Top;
